const isResultsPage = document.querySelector( '.page-template-your-results' ) || document.querySelector( '.page-template-template-wellness-tool-results' );

if ( isResultsPage ) {

	const printResults = document.querySelector( '[data-print-results]' );

	printResults.addEventListener( 'click', () => {
		window.print();
	});

	const shareResults = document.querySelector( '[data-share-results]' );

	shareResults.addEventListener( 'click', () => {
		const siteLinkToCopy = shareResults.closest( '.site-link-holder' );
		const linkToCopy = siteLinkToCopy.querySelector( '[data-link-to-copy]' );
		console.log( siteLinkToCopy, linkToCopy );
		linkToCopy.select();
		linkToCopy.setSelectionRange( 0, 99999 );
		document.execCommand( 'copy' );
		shareResults.focus();
		const copyNotification = siteLinkToCopy.querySelector( '[data-fade-out-copy]' );
		copyNotification.classList.remove( 'dn' );
		copyNotification.classList.remove( 'fade-out' );
		copyNotification.classList.add( 'fade-out' );
	});

}
